export default "__VITE_ASSET__50649f7f__"